/* @ngInject */
function companyService ($state, $timeout, LocalStorageService) {
  const service = {
    reloadWithNewCompany
  }
  return service

  function reloadWithNewCompany () {
    $state.go('home')
    $timeout(() => {
      LocalStorageService.del('lastOriginModule')
      window.location.reload(true)
    }, 200, false)
  }
}

export { companyService }
